<mat-card>
  <mat-card-content class="p-0">
    <app-datatable
      [configurationInput]="datatableConfigurations"
      [rowData]="datatableRows()"
      [columns]="datatableColumns"
      [total]="store.dataTotal$()"
      [customColumnDef]="[{ name: 'isActive', template: isActiveCell, isSortable: true }]"
      (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
      (editClick)="initializeEdit()"
      (addClick)="initializeAdd()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (selectedItemsChange)="selectedDatatableItems.set($event)"
    />
  </mat-card-content>
</mat-card>

<ng-template #isActiveCell let-row="row">
  <mat-chip [ngClass]="row.isActive ? 'green' : 'red'">
    {{ (row.isActive ? 'button.active' : 'button.inactive') | translate | uppercase }}
  </mat-chip>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.controls.name"></mat-error>
        </mat-form-field>
        <mat-dropdown
          class="col-12 mb-3"
          [options]="providerOptions()"
          [configurationInput]="{
            singleSelection: true,
            isClientSide: true,
            hasMatError: true,
            text: 'field.aiProvider' | translate,
            repositionDropdownList: true,
          }"
          [formControl]="addEditForm.controls.aiProviderId"
          [isFormSubmitted]="form.submitted"
        ></mat-dropdown>
        <mat-dropdown
          class="col-12 mb-3"
          [options]="modelOptions()"
          [configurationInput]="{
            singleSelection: true,
            isClientSide: true,
            hasMatError: true,
            text: 'field.model' | translate,
            repositionDropdownList: true,
          }"
          [formControl]="addEditForm.controls.model"
          [isFormSubmitted]="form.submitted"
        ></mat-dropdown>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.instructions' | translate }}</mat-label>
          <textarea matInput rows="6" formControlName="instructions"></textarea>
          <mat-hint>{{ 'page.artificialIntelligence.agentInstructionsHint' | translate }}</mat-hint>
          <mat-error [control]="addEditForm.controls.instructions"></mat-error>
        </mat-form-field>
        <div class="col-12 mt-2">
          <mat-checkbox formControlName="isActive">
            {{ 'field.active' | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
